// video
window.addEventListener('load', function() {
  // var _mql = window.matchMedia('screen and (max-width: 767px)');
  // var _mqlPc = window.matchMedia('screen and (min-width: 768px)');
  // var $video = document.getElementById('js-home-kv');
  // var _videoSrc;
  // var _videoPcSrc;
  // if ($video != null) {
  //   // ▼本番用
  //   //https://recruit.syouei-corp.net/wp-content/themes/recruit/assets/image/
  //   // _videoSrc = 'https://recruit.syouei-corp.net/wp-content/themes/recruit/assets/image/kv/video.mp4';
  //   // _videoPcSrc = 'https://recruit.syouei-corp.net/wp-content/themes/recruit/assets/image/kv/video-pc.mp4';
  //   _videoSrc = './assets/image/kv/video.mp4';
  //   _videoPcSrc = './assets/image/kv/video-pc.mp4';
  //   _mql.addListener(routingByBreakpoint);
  //   // ▼初回ロード時
  //   routingByBreakpoint(_mql);
  //   // console.log('あるしんど');
  // } else {
  //   // console.log('あれ');
  // }
  // // ▼関数
  // function routingByBreakpoint(_mql) {
  //   if (_mql.matches) {
  //     $video.src = _videoSrc;
  //     $video.load();
  //     $video.play();
  //     // console.log('spサイズだお');
  //   } else {
  //     $video.src = _videoPcSrc;
  //     $video.load();
  //     $video.play();
  //     // console.log('pcサイズだお');
  //   }
  // }
});

// var defaultQueryList = {
//   mobile: matchMedia("(max-width: 767px"),
//   pc: matchMedia("(min-width: 768px)")
// };
//
// function routingByBreakpoint(sourceList) {
//   for(var i = 0, l = sourceList.length; i < l; i++){
//     var source = sourceList[i];
//     if(!(source.dataset.query && defaultQueryList[source.dataset.query] && source.dataset.src)) continue;
//     if(!(defaultQueryList[source.dataset.query].matches)) continue;
//     var newSource = document.createElement("source");
//     newSource.src = source.dataset.src;
//     source.parentElement.appendChild(newSource);
//   }
// }
//
// (function (){
//   var elemList = document.getElementsByClassName("routingByBreakpoint");
//   for(var i = 0, l = elemList.length; i < l; i++) {
//     var sourceList = elemList[i].getElementsByTagName("source");
//     routingByBreakpoint(sourceList);
//   }
// })();
